<template>
  <v-dialog v-model="active" persistent max-width="700">
    <v-card>
      <v-card-text class="pb-0">
        <v-row>
          <v-col cols="12" sm="12">
            <p class="headline">Estimado Cliente no Podemos cumplir su pedido en su totalidad</p>
            <ul style="font-weight: 500">
              <li>Los productos <strong>seleccionados</strong> seran facturados con las cantidades disponibles</li>
              <li>Los productos <strong>no disponibles</strong> o <strong>no seleccionados</strong> seran eliminados de su pedido</li>
            </ul>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-simple-table fixed-header height="300px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">COD ART</th>
                    <th class="text-left">Descripción</th>
                    <th class="text-left">Pedido</th>
                    <th class="text-left">Disponible</th>
                    <th class="text-center">Aceptar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,i) in data" :key="i">
                    <td>{{ item.post_id }}</td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.stock_required }}</td>
                    <td>{{ item.stock_deposit }}</td>
                    <td class="text-center">
                      <span v-if="item.stock_deposit > 0">
                        <v-checkbox v-model="item.status" class="ml-12"></v-checkbox>
                      </span>
                      <span v-else>
                        <v-btn
                          x-small
                          text
                          class="mx-2 text-capitalize caption elevation-0"
                          color="grey darken-1"
                        >No Disponible</v-btn>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-progress-linear v-if="progress" indeterminate color="#00BFA6"></v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="updateShoppingCart(data)">Aceptar</v-btn>
        <v-btn color="#b2aaaa" dark @click="$emit('dialog:change', 'cerrar')">Cancelar</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["active", "data", "cart_id"],
  data() {
    return {
      progress: false
    };
  },
  computed: {
    itemsOrders() {
      return this.$store.getters["layout/ORDERS"];
    },
  },
  methods: {
    status() {
      // console.log(this.$refs.inputUpload.value);
      this.$refs.inputUpload.value = true;
    },
    async checkInShoppingCart() {
      try {
        let position_array = this.itemsOrders.findIndex((element) => {
          return element.id == this.cart_id
        })

        const request = {
          cart_id: this.cart_id,
          position: position_array
        };

        // console.log('request',request)

        const response = await this.$store.dispatch(
          "shoppingCart/CHECK_IN_SHOOPING_CART",
          request
        );

        console.log('response carrito',response.data)

        this.progress = false;
        // // this.dialog_verify = false;
        this.$emit("dialog:change", "cerrar");

        Swal.fire({
          title: "Facturado!",
          text: "Su pedido se encuentra en pedidos facturados",
          // imageUrl: "img/check.svg",
          // imageWidth: 400,
          // imageHeight: 200,
          // imageAlt: "factura_aceptada",
          icon: "success",
          confirmButtonColor: "#7160ec"
        });
      } catch (error) {
        // console.log('error bill', error);
        this.$emit("dialog:change", error.response.data);
      }
    },
    async updateShoppingCart(item) {
      try {
        this.progress = true;

        let data_post_id = item
          .filter(function(index) {
            return index.status !== true;
          })
          .map(index => {
            return index.post_id;
          });     

        if (data_post_id.length > 0) {
          const request = {
            items: data_post_id,
            shopping_cart_id: this.cart_id,          
          };

          await this.$store.dispatch(
            "shoppingCart/DELETE_PRODUCT_SHOOPING_CART",
            request
          );
        }   

        this.checkInShoppingCart();
      } catch (error) {
        console.log("Error Updating Shopping", error.response);
      }
    }
  }
};
</script>

<style>
</style>